const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M432.427 405.333H144.064a47.978 47.978 0 0 1-36.437-16.768 47.92 47.92 0 0 1-10.987-38.613l31.552-202.667c3.712-23.552 23.637-40.618 47.445-40.618H464a47.978 47.978 0 0 1 36.437 16.768 47.92 47.92 0 0 1 10.987 38.613l-31.552 202.667c-3.712 23.552-23.637 40.618-47.445 40.618Zm-256.79-266.666c-7.936 0-14.592 5.696-15.808 13.546L128.277 354.88c-.725 4.693.555 9.28 3.648 12.885 3.094 3.584 7.382 5.568 12.139 5.568h288.363c7.936 0 14.592-5.696 15.808-13.546l31.552-202.667c.725-4.693-.555-9.28-3.648-12.885-3.094-3.584-7.382-5.568-12.139-5.568H175.637Z",
    style: {
      fill: "#585858",
      fillRule: "nonzero"
    },
    transform: "matrix(.04297 0 0 .04297 1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.579 287.488c-10.283 0-20.566-2.731-29.782-8.149l-144.682-85.291c-7.616-4.48-10.155-14.293-5.675-21.909 4.501-7.595 14.251-10.176 21.909-5.654l144.704 85.291c7.83 4.608 17.323 4.907 25.451.875l167.424-83.712c7.893-3.947 17.493-.747 21.461 7.146 3.968 7.915.747 17.515-7.168 21.462l-167.424 83.712a58.347 58.347 0 0 1-26.218 6.229ZM90.667 181.333H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h74.667c8.832 0 16 7.168 16 16s-7.168 16-16 16ZM69.333 266.667H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h53.333c8.832 0 16 7.168 16 16s-7.168 16-16 16Z",
    style: {
      fill: "#585858",
      fillRule: "nonzero"
    },
    transform: "matrix(.04297 0 0 .04297 1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 352H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h32c8.832 0 16 7.168 16 16s-7.168 16-16 16Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.04297 0 0 .04297 1 1)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.8dd2257edfa475d9dbd98416ddf0710f.svg";
export { ForwardRef as ReactComponent };